import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

// Admin LTE
import "admin-lte/plugins/fontawesome-free/css/all.min.css";

// Estilos globales
import "@/assets/css/estilos.css";

// DataTables
// import "admin-lte/plugins/datatables/jquery.dataTables";
import "admin-lte/plugins/datatables-bs4/css/dataTables.bootstrap4.min.css";
import "admin-lte/plugins/datatables-responsive/css/responsive.bootstrap4.min.css";
import "admin-lte/plugins/datatables-buttons/css/buttons.bootstrap4.min.css";
import "admin-lte/plugins/datatables-responsive/js/dataTables.responsive.min.js";
import "admin-lte/plugins/datatables-responsive/js/responsive.bootstrap4.min.js";
import "admin-lte/plugins/datatables-buttons/js/dataTables.buttons.min.js";
import "admin-lte/plugins/datatables-buttons/js/buttons.bootstrap4.min.js";
import "admin-lte/plugins/jszip/jszip.min.js";
import "admin-lte/plugins/pdfmake/pdfmake.min.js";
import "admin-lte/plugins/pdfmake/vfs_fonts.js";
import "admin-lte/plugins/datatables-buttons/js/buttons.html5.min.js";
import "admin-lte/plugins/datatables-buttons/js/buttons.print.min.js";
import "admin-lte/plugins/datatables-buttons/js/buttons.colVis.min.js";

// Flags icons
import "flag-icon-css/css/flag-icons.css";

// Keen UI
import KeenUI from "keen-ui";

Vue.config.productionTip = false;
Vue.use(KeenUI);

//v-mask
import VueMask from 'v-mask'
// import { validateToken } from "./constants/general";
Vue.use(VueMask);

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: "pusher",
  key: '38f71ab3876bf6366299', //process.env.VUE_APP_PUSHER_APP_KEY,
  cluster: "us2",
  forceTLS: true
});

// Recorrido de rutas
router.beforeEach(async (to, from, next) => {

  let splitURL = to.path.split("/");
  let pathModule = splitURL[1];

  try {
    let title = to.name.split(/(?=[A-Z])/).join(" ") ?? "Sailor";
    document.title = `Sailor - ${title[0].toUpperCase() + title.slice(1)}`;

  } catch (error) {
    document.title = "Sailor"
  }
  store.state.tokenValidationPage = to.path;


  // Si el usuario no esta logueado
  if (localStorage.getItem("token") == "") {
    // Si no se dirige a la ruta login
    if (to.path != "/login") {
      // Direccionar a login
      next({
        path: "/login",
      });
    }
  } else {
    // Usuario logueado
    if (to.meta.requiresAuth) {
      //
      // Dashboard
      if (to.path == "/") {
        next();
      }

      if (pathModule == "superadministrador") {

        if (to.path == `/${pathModule}/filiales`) {
          store.state.seccionesSuperAdministrador.isFiliales ? next() : next("/");
        }

        if (to.path == `/${pathModule}/mantenedor_regional`) {
          store.state.seccionesSuperAdministrador.isMantenedorRegional ? next() : next("/");
        }

        if (to.path == `/${pathModule}/modulos`) {
          store.state.seccionesSuperAdministrador.isModulos ? next() : next("/");
        }

        if (to.path == `/${pathModule}/roles`) {
          store.state.seccionesSuperAdministrador.isRoles ? next() : next("/");
        }

        if (to.path == `/${pathModule}/secciones`) {
          store.state.seccionesSuperAdministrador.isSecciones ? next() : next("/");
        }

      }

      // Modulo Administración
      if (pathModule == "administracion") {

        if (to.path == `/${pathModule}/clientes`) {
          store.state.seccionesAdministrador.isClientes ? next() : next("/");
        }
        if (to.path == `/${pathModule}/perfil_usuario`) {
          store.state.seccionesAdministrador.isPerfil ? next() : next("/");
        }
        if (to.path == `/${pathModule}/usuarios`) {
          store.state.seccionesAdministrador.isUsuarios ? next() : next("/");
        }

        if (to.path == `/${pathModule}/proveedores`) {
          store.state.seccionesAdministrador.isProveedores ? next() : next("/");
        }
        if (to.path == `/${pathModule}/puertos`) {
          store.state.seccionesAdministrador.isPuertos ? next() : next("/");
        }
        if (to.path == `/${pathModule}/destinos`) {
          store.state.seccionesAdministrador.isDestinos ? next() : next("/");
        }
        if (to.path == `/${pathModule}/contenedores`) {
          store.state.seccionesAdministrador.isContenedores ? next() : next("/");
        }
        if (to.path == `/${pathModule}/pallets`) {
          store.state.seccionesAdministrador.isPallets ? next() : next("/");
        }
        if (to.path == `/${pathModule}/condiciones`) {
          store.state.seccionesAdministrador.isCondiciones ? next() : next("/");
        }
        if (to.path == `/${pathModule}/naves`) {
          store.state.seccionesAdministrador.isNaves ? next() : next("/");
        }
        if (to.path == `/${pathModule}/navieras`) {
          store.state.seccionesAdministrador.isNavieras ? next() : next("/");
        }
        if (to.path == `/${pathModule}/productos`) {
          store.state.seccionesAdministrador.isProductos ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tiempo_limite_de_planificaciones`) {
          store.state.seccionesAdministrador.isLimitePlanificaciones ? next() : next("/");
        }
        if (to.path == `/${pathModule}/temporadas`) {
          store.state.seccionesAdministrador.isTemporadas ? next() : next("/");
        }
        if (to.path == `/${pathModule}/embarcadores`) {
          store.state.seccionesAdministrador.isEmbarcadores ? next() : next("/");
        }

        // Modulo Lineas
      }

      // Modulo Lineas
      if (pathModule == "lineas" && store.state.modulosLogin.isLineas) {

        if (to.path == `/${pathModule}/buscar_bl`) {
          !store.state.isAdmin ? next() : next(false);
        }
        if (to.path == `/${pathModule}/planificacion_anual`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/planificacion_semanal`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/servicios`) {
          !store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/booking/booking_no_planificado`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/booking/bookings_declarados`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/booking/bookings_solicitados`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/booking/bookings_confirmados`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/booking/solicitudes_modificacion`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/booking/bookings_embarcados`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/booking/late_arrivals`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/booking/bookings_cancelados`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/general_lineas`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tarifas/contratos`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tarifas/acuerdos_lineas`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tarifas/acuerdos_clientes_base`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tarifas/acuerdos_clientes`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tarifas/tarifas_lineas`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tarifas/descuentos_clientes`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tarifas/reporte_tarifa_embarcador`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/itinerarios`) {
          store.state.isAdmin ? next() : next("/");
        }
        if (to.path == `/${pathModule}/tracking`) {
          store.state.isAdmin ? next() : next("/");
        }
      }

      if (pathModule == "charter" && store.state.modulosLogin.isCharter) {
        if (to.path == `/${pathModule}/planificacion_anual`) {
          !store.state.isAdmin ? next() : next(false);
        }
      }
    }
  }
  next();
});

const vm = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export { vm };
